// extracted by css-extract-rspack-plugin
export default {"container":"SandboxView-module__container__kwzZE","iframe":"SandboxView-module__iframe__xTUj4"};